<template>
    <CreateModelLayout
        :indexRoute="$route('admin::companies.index')"
        :storeRoute="$route('admin::companies.store')"
        :modelNameSingular="__('admin::companies.company')"
        :modelNamePlural="__('admin::companies.companies')"
        :form="form"
    >

        <FormGroup :label="__('admin::labels.name')" :error="errors.name">
            <Input name="name" type="text" :has-error="exists(errors.name)" v-model="form.name" :required="true" />
        </FormGroup>

    </CreateModelLayout>
</template>

<script>
    export default {
        props: {
            errors: Object,
        },
        data() {
            return {
                form: this.$inertia.form({
                    name: null,
                })
            }
        },
    }
</script>
